import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

const articleImages: Record<string, string> = {
  'article-1': 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20movie%20and%20video%20streaming%20scene%20with%20soft%20ambient%20lighting%2C%20modern%20entertainment%20technology%20aesthetic%2C%20abstract%20geometric%20elements%20with%20orange%20and%20warm%20tones%2C%20clean%20composition%20with%20depth%2C%20editorial%20photography%20style%2C%20no%20text%20or%20people&width=800&height=450&seq=mango-review-article-1&orientation=landscape',
  'article-2': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20comparison%20layout%20with%20warm%20orange%20and%20teal%20accents%2C%20abstract%20geometric%20background%20representing%20multiple%20platforms%2C%20soft%20gradient%20with%20cinematic%20lighting%2C%20clean%20tech%20aesthetic%2C%20no%20text&width=800&height=450&seq=platform-compare-article-2&orientation=landscape',
  'article-3': 'https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20and%20movie%20posters%20in%20warm%20ambient%20lighting%2C%20abstract%20summer%20vibes%20with%20golden%20hour%20tones%2C%20theater%20curtains%20in%20soft%20focus%2C%20entertainment%20atmosphere%2C%20no%20text%20or%20people&width=800&height=450&seq=summer-movie-article-3&orientation=landscape',
  'article-4': 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20video%20streaming%20app%20interface%20with%20warm%20orange%20theme%2C%20modern%20mobile%20device%20on%20clean%20desk%20with%20soft%20natural%20lighting%2C%20minimalist%20tech%20lifestyle%20aesthetic%2C%20no%20visible%20text&width=800&height=450&seq=app-guide-article-4&orientation=landscape',
  'article-5': 'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20scene%20with%20warm%20lighting%20and%20soft%20bokeh%20background%2C%20abstract%20representation%20of%20Chinese%20TV%20drama%2C%20elegant%20composition%20with%20golden%20and%20amber%20tones%2C%20storytelling%20atmosphere%2C%20no%20people%20or%20text&width=800&height=450&seq=drama-guide-article-5&orientation=landscape',
  'article-6': 'https://readdy.ai/api/search-image?query=Warm%20welcoming%20community%20atmosphere%20with%20soft%20glowing%20highlights%2C%20abstract%20representation%20of%20user%20satisfaction%20and%20ratings%2C%20modern%20interface%20elements%20in%20orange%20and%20warm%20tones%2C%20clean%20minimalist%20design%2C%20no%20text&width=800&height=450&seq=user-feedback-article-6&orientation=landscape',
};

function getCategoryName(slug: string): string {
  const map: Record<string, string> = {
    recommend: '热门推荐',
    movie: '电影',
    tv: '电视剧',
    variety: '综艺',
    anime: '动漫',
    documentary: '纪录片',
  };
  return map[slug] || slug;
}

export default function FeaturedArticles() {
  const featuredArticles = articles.slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-2">
              热门推荐
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              精选优质内容，发现更多精彩
            </p>
          </div>
          <Link
            to="/category/recommend"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative w-full h-48 md:h-52 overflow-hidden">
                <img
                  src={articleImages[article.id]}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-primary-500/90 text-background-50 rounded-full whitespace-nowrap">
                    {getCategoryName(article.category)}
                  </span>
                </div>
              </div>

              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-semibold font-heading text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.date}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}